export default __webpack_public_path__ + "static/media/15.adedea58.jpg";